import React, { useState, useEffect } from 'react';
import FormInput from './FormInput';
import FormLabel from './FormLabel';
import Button from './Button';
import BlockTitle from './BlockTitle';
import { collection, addDoc, doc, updateDoc } from "firebase/firestore";
import { firestore } from "../lib/firebaseConfig";
import { useToast } from '../context/ToastContext';

const AddEditFlat = ({ flat = null, onSave, onCancel, investmentId }) => {
  const { showError } = useToast();
  const [formData, setFormData] = useState({
    code: '',
    floor: '',
    size: '',
    type: 'residential',
    status: 'available',
    an_amount: '',
  });

  // Populate form data if editing an existing flat
  useEffect(() => {
    if (flat) {
      setFormData(flat);
    }
  }, [flat]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const flatData = {
        ...formData,
        investmentId,
        an_amount: parseFloat(formData.an_amount) || 0,
        paid_amount: 0,
        paid_out_amount: 0,
        reservation_amount: 0,
        paid_date: null,
        paid_back_amount: 0,
        paid_back_date: null,
        paid_to_corp: 0,
        date_paid_to_corp: null,
        left_for_corp_amount: 0,
        comment: '',
        mandatory_amount: 0,
        missing_amount: 0
      };

      if (flat && flat.id) {
        // Update existing flat
        const flatRef = doc(firestore, `investments/${investmentId}/flats/${flat.id}`);
        await updateDoc(flatRef, flatData);
        console.log("Flat updated with ID: ", flat.id);
        onSave({ id: flat.id, ...flatData });
      } else {
        // Add new flat
        const docRef = await addDoc(collection(firestore, `investments/${investmentId}/flats`), flatData);
        console.log("Flat added with ID: ", docRef.id);
        onSave({ id: docRef.id, ...flatData });
      }
    } catch (error) {
      console.error("Error saving flat: ", error);
      showError("Nie udało się zapisać danych lokalu.");
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <div className="font-figtree max-h-[calc(100vh-40px)]">
      <BlockTitle className="text-[22px]">
        {flat ? 'Edytuj lokal' : 'Dodaj lokal'}
      </BlockTitle>

      <form
        onSubmit={handleSubmit}
        className="grid max-600:block max-600:space-y-4 md:grid-cols-2 gap-4 mt-8 "
      >
        <div>
          <FormLabel htmlFor="code">Kod lokalu</FormLabel>
          <FormInput
            id="code"
            name="code"
            value={formData.code}
            onChange={onChange}
            placeholder="Podaj kod lokalu"
            required
          />
        </div>

        <div>
          <FormLabel htmlFor="floor">Piętro</FormLabel>
          <FormInput
            id="floor"
            type="number"
            name="floor"
            value={formData.floor}
            onChange={onChange}
            placeholder="Podaj numer piętra"
            required
          />
        </div>

        <div>
          <FormLabel htmlFor="size">Powierzchnia (m²)</FormLabel>
          <FormInput
            id="size"
            type="number"
            name="size"
            value={formData.size}
            onChange={onChange}
            placeholder="Podaj powierzchnię w m²"
            required
          />
        </div>

        <div>
          <FormLabel htmlFor="type">Typ lokalu</FormLabel>
          <select
            id="type"
            name="type"
            value={formData.type}
            onChange={onChange}
            className="w-full border rounded-md px-3 py-2"
            required
          >
            <option value="residential">Mieszkalne</option>
            <option value="commercial">Usługowe</option>
          </select>
        </div>
        <div>
          <FormLabel htmlFor="size">Cena brutto</FormLabel>
          <FormInput
            id="an_amount"
            type="number"
            name="an_amount"
            value={formData.an_amount}
            onChange={onChange}
            placeholder="Podaj cenę brutto"
            required
          />
        </div>
        <div className="col-span-2 flex justify-end space-x-2 pb-8 mt-10">
          <Button type="submit" variant="default">
            Zapisz
          </Button>        
          <Button type="button" variant="bordered" onClick={onCancel}>
            Anuluj
          </Button>

        </div>
      </form>
    </div>
  );
};

export default AddEditFlat;
